import React from 'react'
import { withRouter } from "react-router-dom";
import TableComponent, { TableOp } from '../../../../components/table/TableOps';
import Destinatario from './DestinatarioNuevo';

class Destinatarios extends TableComponent {
	componentDidMount() {
		const { params } = this.props.match;
		// console.log(this.props)
		this.tableConfig(
			{ dataUrl: `cliente-destinatario/${this.props.match.params.id}/filter`, deleteUrl: 'cliente-destinatario/delete', deleteField: 'cliente_dests_nombre', modUrl: `/Catalogo/Cliente/${params.id}/Destinatarios`, query: { id_cliente: params.id } },
			TableOp.Table('Destinatarios', [
				// { label: 'Clave', id: 'cliente_dests' },
				{ label: 'Clave', id: 'cliente_dests' },
				{ label: 'Destinatario', id: 'cliente_dests_nombre' },
				{ label: 'Teléfono', id: 'cliente_dests_telefono' },
				{ label: 'Domicilio', id: 'cliente_dests_domicilio' },
				{ label: 'Colonia', id: 'colonia' },
				{ label: 'Ciudad', id: 'ciudad' },
				{ label: 'Estado', id: 'estado' },
				{ label: 'C.P.', id: 'cliente_dests_cp' },
			], [
				{ id: 'edit', icon: 'edit' },
				{ id: 'delete', icon: 'delete' },
			])
		);
		this.table();
	}

	render() {
		return (
			<div>
				<div>
					<Destinatario onSave={() => { this.table() }}></Destinatario>
					<this.TableRender />
				</div>
			</div>
		)
	}
}

export default withRouter(Destinatarios);
